import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="25"
    height="16"
    viewBox="0 0 25 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.08247 15.3256C12.2238 15.3256 15.581 12.0225 15.581 7.94798C15.581 3.87341 12.2238 0.570312 8.08247 0.570312C3.94117 0.570312 0.583984 3.87341 0.583984 7.94798C0.583984 12.0225 3.94117 15.3256 8.08247 15.3256Z"
      fill="#EB001B"
    />
    <path
      d="M17.1391 15.3256C21.2804 15.3256 24.6376 12.0225 24.6376 7.94798C24.6376 3.87341 21.2804 0.570312 17.1391 0.570312C12.9978 0.570312 9.64062 3.87341 9.64062 7.94798C9.64062 12.0225 12.9978 15.3256 17.1391 15.3256Z"
      fill="#F79E1B"
    />
    <path
      d="M12.6086 2.05566C14.4141 3.40174 15.5766 5.53486 15.5766 7.93279C15.5766 10.3307 14.4141 12.4675 12.6086 13.8136C10.8032 12.4675 9.64062 10.3344 9.64062 7.93279C9.64062 5.53118 10.8069 3.40174 12.6086 2.05566Z"
      fill="#FF5F00"
    />
  </SvgIcon>
));
